import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface LinkChipProps extends BoxProps {
	active?: boolean;
}

/** An adornment for NavLinkMain */
const LinkChip = ({ active, sx, ...rest }: LinkChipProps) => {
	return (
		<Box
			sx={combineSx(
				({ borderRadius, size, vars }) => ({
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: vars.palette.uc.bg.medium,
					typography: 'label-sm',
					paddingX: 100,
					paddingY: 50,
					borderRadius: borderRadius.roundedXS,
					color: vars.palette.uc.text.main,
					height: size.sm,
					transition: 'background-color 0.2s ease-out, color 0.2s ease-out',

					...(active && {
						backgroundColor: vars.palette.uc.highlight.bg.strong,
						color: vars.palette.uc.text.strong,
					}),
				}),
				sx,
			)}
			{...rest}
		/>
	);
};

export default LinkChip;
